export default {
    data() {
        return {
            reviewTypes: [
                {value: 'cr', label: 'Comprehensive Review', mailtemplate: 'Comprehensive_Review_Invitation'},
                {value: 'fr', label: 'Focused Review', mailtemplate: 'Focused_Review_Invitation'},
                {value: 'mr', label: 'Maintenance Review', mailtemplate: 'Maintenance_Review_Invitation'}
            ],
            changeTypeColors: {
                minor: '#677EEA',
                major: '#ED742A',
                none: '#38B2AD'
            }
        }
    },
    computed: {
        showFullEditLink() {
            
            switch(this._data._class) {
                case 'Mail':
                case 'MailTemplateBlock':
                case 'Stripactivity':
                case 'Mailtemplate':
                case 'Hoster':
                case 'Domain':
                case 'Service':
                case 'User':
                    return false;
                    break;
                default:
                    return true;
                    break;
            }
        },
    },
    methods: {

        formatDate(value) {
            if (!value) return '-';
            var e = value.split(' ');
            if (e.length==2) {
              var e2 = e[0].split('-');
              var e3 = e[1].split(':');
              return e2[2]+'-'+e2[1]+'-'+e2[0]+', '+e3[0]+':'+e3[1]+'h';
            }
            else if (e.length==1) {
              var e2 = value.split('-');
              return e2[2]+'-'+e2[1]+'-'+e2[0];
            }
            else {
              //console.log(e.length)
              return '-';
            }
            
        },

        getReviewTypeName(type) {
            return this.reviewTypes.find(reviewType=>reviewType.value==type)?.label;
        },
        getCustomPath(type,controller,id) {
            
            switch(controller) {
                case 'knownissues':
                    if (type=='edit') return '/knowledgebase/knownissue_edit/'+id;
                    if (type=='details') return '/knowledgebase/knownissue/'+id;
                    break;  
            }
        
            return false;
        },
        
        getEditSubTitle() {
            
            var entityName = this._entity._class;
            switch(this._entity._class) {
                case 'MemberOrganisation':    entityName = ''; break;
                case 'Contactperson':         entityName = 'Contactpersoon'; break;
                case 'Project':               entityName = 'Project'; break;
                case 'Customer':              entityName = 'Klantgegevens'; break;
                case 'Invoice':               entityName = 'Factuur'; break;
                case 'Stripactivity':         entityName = ''; break;
                case 'Hoster':                entityName = ''; break;
                case 'Knownissue':            entityName = ''; break;
                case 'User':            entityName = ''; break;
            }
            return entityName;
            
        },
        customEditTitle(data) {
            let entityName = this.getEditTitle();
            if (!data.id) return 'Create '+entityName;
            return 'Edit '+entityName;
        },
        getEditTitle() {
            var entityName = this._entity._class;
            switch(this._entity._class) {
                case 'MemberOrganisation':  entityName = 'Member organisation'; break;
                case 'Contactperson':       entityName = 'Contactpersoon'; break;
                case 'Project':             entityName = 'Project'; break;
                case 'Customer':            entityName = 'Klant'; break;
                case 'Stripactivity':            entityName = 'Activiteit'; break;
                case 'Hoster':            entityName = 'Hostingpartner'; break;
                case 'Domain':            entityName = 'Domeinregistratie'; break;
                case 'Knownissue':            entityName = 'Item'; break;
                case 'User':            entityName = 'User'; break;
                
            }
            return entityName;
            
        },
        getEditName(data) {
            if (!data.id) return '';
            var html = [];

            
            switch(data._class) {
                case 'BaseCourse':
                case 'Course':
                case 'CourseLocation':
                case 'Customer':    
                    html.push(data.name+' - ID: '+data.id);
                    break;
                case 'Participant':    
                    html.push(data.fullname+'  ('+data.Customer.name+')');
                    break;
                case 'User':    
                    html.push(data.fullname+' - ID: '+data.id);
                    break;
                case 'MailTemplate':    
                    html.push((data.BaseCourse.acronym?data.BaseCourse.acronym:'Default')+(data.type?' - '+data.type+' template':''));
                    break;
                case 'Enrollment':    
                    html.push(data.Participant.fullname+'  ('+data.Customer.name+')');
                    break;
                case 'BaseCourseAction':    
                    html.push(data.BaseCourse.name);
                    break;
            }
            return html.join('<br />');
        },
    }
}
